type RegionFormat = {
  hasToInclude: boolean;
  defaultValue: string;
  valueFormatted: string;
};

const regionsToBeFormatted: RegionFormat[] = [
  {
    hasToInclude: true,
    defaultValue: 'ALTO PARANA',
    valueFormatted: 'ALTO PARANA',
  },
  { hasToInclude: false, defaultValue: 'PARAGUAY', valueFormatted: 'CENTRAL' },
];

export const formatRegion = (value: string) => {
  return (
    // eslint-disable-next-line
    regionsToBeFormatted.find((region) => {
      if (region.hasToInclude) {
        if (value?.includes(region.defaultValue)) return region;
      } else if (value === region.defaultValue) return region;
    })?.valueFormatted ?? value
  );
};
